import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { NumericInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type MainProps = {
  isLoading: boolean
  disabled: boolean
}

export function Main({ isLoading, disabled }: MainProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('basic information')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={12}>
          <TextInput
            name='name'
            label='form.designation'
            skeletonShow={isLoading}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={12}>
          <TextInput
            name='full_name'
            label='form.full designation'
            skeletonShow={isLoading}
            readOnly={disabled}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            name='inn'
            label='form.inn'
            skeletonShow={isLoading}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '' }}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            name='kpp'
            label='form.kpp'
            skeletonShow={isLoading}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '' }}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            name='ogrn'
            label='form.ogrn'
            skeletonShow={isLoading}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '' }}
          />
        </Grid>
        <Grid xs={12}>
          <NumericInput
            name='okpo'
            label='form.okpo'
            skeletonShow={isLoading}
            readOnly={disabled}
            numericProps={{ thousandSeparator: '' }}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
